
/*
 UXS — SHARE SIGNAL V8
 DAY2K / UNIDOS X EL SONIDO

 - Mantiene COMPARTIR / NO COMPARTIR
 - Mantiene integración con incoming.js
 - Mantiene pregunta al grabar
 - Mantiene botón de regrabación
 - Envía temporalmente voz original
 - Guarda únicamente MP3 transformado
   a través de uxs-save-signal V5

 No modifica UXSTranscription,
 UXSVocoder ni el visualizador.
*/

(function () {
  "use strict";

  const ENABLE_PRIVATE_UPLOAD = true;

  const SUPABASE_URL =
    "https://owwcdrqwfevwbkubrlff.supabase.co";

  const SUPABASE_KEY =
    "sb_publishable_xn5hzUtHdOZNJZ0eRZLr_g_3SmeqUS4";

  const FUNCTION_NAME = "uxs-save-signal";

  function init() {
    const root =
      document.getElementById("uxs-experience");

    const recording =
      document.getElementById("uxs-recording");

    if (!root || !recording) return;
    if (root.dataset.shareReady === "v8") return;

    root.dataset.shareReady = "v8";

    document.getElementById(
      "uxs-share-styles"
    )?.remove();

    const style = document.createElement("style");

    style.id = "uxs-share-styles";

    style.textContent = `
      #uxs-share-panel {
        display: none;
        box-sizing: border-box;
        width: min(90vw, 430px);
        margin: 0 auto;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 18px;
        color: #fff;
        text-align: center;
        font-family: monospace;
      }

      #uxs-share-panel.uxs-visible {
        display: flex !important;
        animation: uxs-share-appear .9s ease both;
      }

      #uxs-share-panel .uxs-share-question {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 17px;
      }

      #uxs-share-symbol {
        display: grid;
        place-items: center;
        width: 42px;
        height: 42px;
        margin: 0 auto 4px;
        color: rgba(255,255,255,.72);
      }

      #uxs-share-symbol svg {
        width: 36px;
        height: 36px;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.1;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      #uxs-share-panel .uxs-share-heading {
        width: 100%;
        max-width: 420px;
        margin: 0 auto;
        color: #fff;
        font-size: clamp(14px, 2.6vw, 19px);
        font-weight: 400;
        line-height: 1.7;
        letter-spacing: 2px;
        text-align: center;
      }

      #uxs-share-panel .uxs-share-description {
        width: 100%;
        max-width: 345px;
        margin: 0 auto;
        color: rgba(255,255,255,.58);
        font-size: 10px;
        line-height: 2;
        letter-spacing: 1px;
        text-align: center;
      }

      #uxs-share-panel .uxs-share-actions,
      #uxs-share-panel .uxs-share-ending-actions {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: min(100%, 320px);
        gap: 12px;
        margin: 8px auto 0;
      }

      #uxs-share-panel button {
        appearance: none;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 100%;
        min-height: 48px;
        padding: 13px 20px;
        border: 1px solid rgba(255,255,255,.45);
        border-radius: 999px;
        background: transparent;
        color: #fff;
        font: 11px/1.6 monospace;
        letter-spacing: 1.3px;
        cursor: pointer;
        transition:
          opacity .5s ease,
          background .35s ease,
          border-color .35s ease;
      }

      #uxs-share-panel button:hover {
        background: rgba(255,255,255,.08);
        border-color: #fff;
      }

      #uxs-share-panel button:disabled {
        opacity: .35;
        cursor: not-allowed;
      }

      #uxs-share-no {
        color: rgba(255,255,255,.65) !important;
        border-color: rgba(255,255,255,.25) !important;
      }

      #uxs-share-panel .uxs-share-privacy {
        width: 100%;
        max-width: 365px;
        margin: 6px auto 0;
        color: rgba(255,255,255,.42);
        font-size: 9px;
        line-height: 1.9;
        letter-spacing: .55px;
      }

      #uxs-share-feedback {
        min-height: 18px;
        max-width: 360px;
        margin: 0 auto;
        color: rgba(255,255,255,.6);
        font-size: 10px;
        line-height: 1.9;
        overflow-wrap: anywhere;
      }

      #uxs-share-ending {
        display: none;
        width: 100%;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 22px 4px;
        text-align: center;
      }

      #uxs-share-panel.uxs-finished
      .uxs-share-question {
        display: none;
      }

      #uxs-share-panel.uxs-finished
      #uxs-share-ending {
        display: flex;
      }

      #uxs-share-retry {
        display: none !important;
      }

      #uxs-share-panel.uxs-can-retry
      #uxs-share-retry {
        display: flex !important;
      }

      .uxs-question-reminder {
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        width: min(90vw, 390px);
        margin: 8px auto;
        padding: 12px 8px;
        color: rgba(255,255,255,.8);
        font: 11px/1.8 monospace;
        letter-spacing: .7px;
        text-align: center;
      }

      .uxs-question-reminder-label {
        color: rgba(255,255,255,.4);
        font-size: 9px;
        letter-spacing: 1.6px;
        margin-bottom: 8px;
      }

      #uxs-first-question-subtitle,
      #uxs-share-rejection-question {
        display: none;
        border-top: 1px solid rgba(255,255,255,.15);
      }

      #uxs-share-panel.uxs-finished
      #uxs-share-rejection-question.uxs-has-question {
        display: flex;
      }

      #uxs-experience.uxs-share-stage
      #uxs-audio-interface,
      #uxs-experience.uxs-share-stage
      #uxs-transcription-panel {
        display: none !important;
      }

      #uxs-experience.uxs-share-stage
      #uxs-recording {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: min(90vw,600px);
        margin: 0 auto !important;
        padding: 0;
        gap: 0 !important;
      }

      #uxs-experience.uxs-share-stage
      #uxs-main {
        display: flex !important;
        flex-direction: column;
        align-items: center !important;
        justify-content: center !important;
        width: 100%;
        min-height: 100svh;
        box-sizing: border-box;
        padding: 25px 16px !important;
      }

      #uxs-experience.uxs-share-stage
      #uxs-visualizer {
        margin: 0 auto 8px !important;
      }

      @keyframes uxs-share-appear {
        from {
          opacity: 0;
          transform: translateY(17px);
        }

        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @media (max-width:600px) {
        #uxs-share-panel .uxs-share-heading {
          font-size: 14px;
        }

        #uxs-share-panel .uxs-share-actions {
          width: min(100%,300px);
        }
      }
    `;

    document.head.appendChild(style);

    document.getElementById(
      "uxs-share-panel"
    )?.remove();

    const panel = document.createElement("section");

    panel.id = "uxs-share-panel";

    panel.innerHTML = `
      <div class="uxs-share-question">
        <div id="uxs-share-symbol" aria-hidden="true">
          <svg viewBox="0 0 40 40">
            <path d="M4 20H8 M11 14V26
              M15 7V33 M20 11V29
              M25 5V35 M30 14V26
              M34 20H37"/>
          </svg>
        </div>

        <div class="uxs-share-heading">
          ¿QUIERES QUE ALGUIEN MÁS LO ESCUCHE?
        </div>

        <p class="uxs-share-description">
          HAY ALGUIEN QUE QUIZÁ ENTIENDA
          LO QUE QUIERES DECIR.
        </p>

        <div class="uxs-share-actions">
          <button id="uxs-share-yes" type="button">
            COMPARTIR MI SEÑAL
          </button>

          <button id="uxs-share-no" type="button">
            NO COMPARTIR
          </button>
        </div>

        <p class="uxs-share-privacy">
          SI COMPARTES, ENVIAREMOS TEMPORALMENTE
          TU GRABACIÓN ORIGINAL PARA VERIFICAR
          TUS PALABRAS. EL AUDIO ORIGINAL SERÁ
          PROCESADO POR NUESTRO SERVIDOR Y EL
          SERVICIO DE TRANSCRIPCIÓN.

          SOLO CONSERVAREMOS EN UXS
          TU VOZ TRANSFORMADA, LA TRANSCRIPCIÓN
          Y LA PREGUNTA. LA SEÑAL PASARÁ
          POR UNA REVISIÓN AUTOMÁTICA.
        </p>
      </div>

      <div id="uxs-share-ending">
        <div
          class="uxs-share-heading"
          id="uxs-share-ending-title">
          TU SEÑAL SE QUEDA CONTIGO.
        </div>

        <p
          class="uxs-share-description"
          id="uxs-share-ending-description">
          GRACIAS POR DEJARNOS ESCUCHARTE.
        </p>

        <div
          id="uxs-share-rejection-question"
          class="uxs-question-reminder">
          <div class="uxs-question-reminder-label">
            RECUERDA LA PREGUNTA
          </div>
          <div id="uxs-share-question-text"></div>
        </div>

        <div class="uxs-share-ending-actions">
          <button
            id="uxs-share-retry"
            type="button">
            ← VOLVER A GRABAR
          </button>
        </div>
      </div>

      <p
        id="uxs-share-feedback"
        role="status"
        aria-live="polite">
      </p>
    `;

    recording.appendChild(panel);

    document.getElementById(
      "uxs-first-question-subtitle"
    )?.remove();

    const subtitle = document.createElement("div");

    subtitle.id = "uxs-first-question-subtitle";
    subtitle.className = "uxs-question-reminder";

    subtitle.innerHTML = `
      <div class="uxs-question-reminder-label">
        TU PREGUNTA
      </div>
      <div id="uxs-first-question-text"></div>
    `;

    recording.insertBefore(
      subtitle,
      recording.firstChild
    );

    const yes = panel.querySelector("#uxs-share-yes");
    const no = panel.querySelector("#uxs-share-no");
    const retry = panel.querySelector("#uxs-share-retry");

    const feedback =
      panel.querySelector("#uxs-share-feedback");

    const endingTitle =
      panel.querySelector("#uxs-share-ending-title");

    const endingDescription =
      panel.querySelector("#uxs-share-ending-description");

    const rejectionQuestion =
      panel.querySelector("#uxs-share-rejection-question");

    const rejectionQuestionText =
      panel.querySelector("#uxs-share-question-text");

    const subtitleText =
      subtitle.querySelector("#uxs-first-question-text");

    let confirmedText = "";
    let confirmedPath = "";
    let confirmedQuestion = "";

    let waitingForMP3 = false;
    let busy = false;
    let client = null;
    let generation = 0;

    function emit(name, detail = {}) {
      root.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail
        })
      );
    }

    function getMP3() {
      return window.UXSMP3?.getBlob?.() || null;
    }

    function pauseAudio() {
      document.getElementById(
        "uxs-playback"
      )?.pause();

      document.getElementById(
        "uxs-vocoder-player"
      )?.pause();
    }

    function getQuestion() {
      return String(
        window.UXSSession?.deepQuestion ||
        confirmedQuestion ||
        ""
      ).trim();
    }

    function updateQuestion() {
      const question = getQuestion();

      subtitleText.textContent = question;
      rejectionQuestionText.textContent = question;

      rejectionQuestion.classList.toggle(
        "uxs-has-question",
        Boolean(question)
      );

      const sharing =
        root.classList.contains("uxs-share-stage");

      const transcription =
        document.getElementById(
          "uxs-transcription-panel"
        );

      const audioInterface =
        document.getElementById(
          "uxs-audio-interface"
        );

      const transcriptionVisible =
        transcription &&
        getComputedStyle(transcription).display !== "none";

      const controlsVisible =
        audioInterface &&
        getComputedStyle(audioInterface).display !== "none";

      subtitle.style.display =
        question &&
        controlsVisible &&
        !transcriptionVisible &&
        !sharing
          ? "flex"
          : "none";
    }

    const interval = setInterval(
      updateQuestion,
      400
    );

    window.addEventListener(
      "pagehide",
      () => clearInterval(interval),
      { once: true }
    );

    function show() {
      pauseAudio();

      root.classList.add("uxs-share-stage");

      panel.classList.remove(
        "uxs-finished",
        "uxs-can-retry"
      );

      panel.classList.add("uxs-visible");

      feedback.textContent = "";
      yes.disabled = false;
      no.disabled = false;

      updateQuestion();
    }

    function finish(title, description, canRetry = false) {
      endingTitle.textContent = title;
      endingDescription.textContent = description;

      feedback.textContent = "";

      panel.classList.toggle(
        "uxs-can-retry",
        canRetry
      );

      panel.classList.add("uxs-finished");

      updateQuestion();
    }

    function reset() {
      generation++;
      busy = false;
      waitingForMP3 = false;

      confirmedText = "";
      confirmedPath = "";
      confirmedQuestion = "";

      root.classList.remove("uxs-share-stage");

      panel.classList.remove(
        "uxs-visible",
        "uxs-finished",
        "uxs-can-retry"
      );

      feedback.textContent = "";

      yes.disabled = false;
      no.disabled = false;

      updateQuestion();
    }

    // Reutilizar los controles reales
    // del grabador para regresar a grabar.

    function requestRerecord() {
      if (busy) return;

      const selectors = [
        "#uxs-rerecord",
        "#uxs-rerecord-btn",
        "#uxs-record-again",
        "#uxs-record-again-btn",
        '[data-uxs-action="rerecord"]'
      ];

      let control = null;

      for (const selector of selectors) {
        const candidate =
          root.querySelector(selector);

        if (
          candidate &&
          !panel.contains(candidate)
        ) {
          control = candidate;
          break;
        }
      }

      if (!control) {
        control = Array.from(
          root.querySelectorAll("button")
        ).find(button => {
          if (
            panel.contains(button) ||
            button.disabled
          ) {
            return false;
          }

          const text =
            (button.textContent || "")
              .trim().toUpperCase();

          return (
            text.includes("VOLVER A GRABAR") ||
            text.includes("GRABAR DE NUEVO") ||
            text.includes("REGRABAR")
          );
        });
      }

      if (!control) {
        feedback.textContent =
          "NO ENCONTRÉ EL CONTROL DE REGRABACIÓN.";

        emit("uxs:share-rerecord-unavailable");
        return;
      }

      control.click();
      reset();
    }

    retry.addEventListener(
      "click",
      requestRerecord
    );

    function getClient() {
      if (!ENABLE_PRIVATE_UPLOAD) {
        throw new Error("UPLOAD_NOT_ENABLED");
      }

      if (!window.supabase?.createClient) {
        throw new Error("SUPABASE_NOT_LOADED");
      }

      if (!client) {
        client = window.supabase.createClient(
          SUPABASE_URL,
          SUPABASE_KEY,
          {
            auth: {
              persistSession: true,
              autoRefreshToken: true,
              detectSessionInUrl: false
            }
          }
        );
      }

      return client;
    }

    async function ensureSession(supa) {
      const { data, error } =
        await supa.auth.getSession();

      if (error) throw error;

      if (data.session?.access_token) {
        return;
      }

      const response =
        await supa.auth.signInAnonymously();

      if (
        response.error ||
        !response.data.session
      ) {
        throw response.error ||
          new Error("AUTH_FAILED");
      }
    }

    async function getFunctionError(error) {
      const context = error?.context;
      let body = null;

      try {
        if (typeof context?.clone === "function") {
          body = await context.clone().json();
        } else if (
          typeof context?.json === "function"
        ) {
          body = await context.json();
        }
      } catch (_) {}

      return {
        status: context?.status ?? null,
        code: body?.error || body?.code || "",
        body
      };
    }

    function handleUploadError({ status, code }) {
      if (
        code === "DAILY_LIMIT_REACHED" ||
        status === 429
      ) {
        finish(
          "POR HOY, TU SEÑAL DESCANSA.",
          "YA ALCANZASTE EL LÍMITE DE TRES ENVÍOS."
        );
        return;
      }

      if (
        code === "ORIGINAL_TEXT_UNCERTAIN" ||
        code === "ORIGINAL_VERIFICATION_FAILED"
      ) {
        finish(
          "NO PUDE CONFIRMAR TUS PALABRAS.",
          "LA VERIFICACIÓN NO PUDO RELACIONAR " +
          "EL AUDIO ORIGINAL CON EL TEXTO. " +
          "REVISA TU RESPUESTA O INTENTA GRABARLA OTRA VEZ.",
          true
        );
        return;
      }

      if (
        code === "INVALID_ORIGINAL_AUDIO" ||
        code === "UNSUPPORTED_ORIGINAL_AUDIO"
      ) {
        finish(
          "NO PUDE REVISAR TU GRABACIÓN.",
          "EL AUDIO ORIGINAL NO TIENE UN FORMATO VÁLIDO.",
          true
        );
        return;
      }

      if (
        code === "INVALID_MP3" ||
        code === "INVALID_TRANSCRIPT" ||
        code === "INVALID_QUESTION"
      ) {
        finish(
          "NO PUDIMOS PREPARAR TU SEÑAL.",
          "REVISA LA GRABACIÓN Y LA PREGUNTA.",
          true
        );
        return;
      }

      if (
        status === 401 ||
        code === "INVALID_SESSION"
      ) {
        finish(
          "NO PUDIMOS RECONOCER TU SESIÓN.",
          "RECARGA LA PÁGINA PARA INTENTARLO OTRA VEZ."
        );
        return;
      }

      finish(
        "NO PUDIMOS CONFIRMAR EL ENVÍO.",
        "REVISA SUPABASE ANTES DE REINTENTAR " +
        "PARA EVITAR SUBIDAS DUPLICADAS."
      );
    }

    // Eventos existentes de UXS.

    root.addEventListener(
      "uxs:transcription-confirmed",
      event => {
        const detail = event.detail || {};

        confirmedText =
          String(detail.text || "").trim();

        confirmedPath = String(
          detail.path ||
          window.UXSSession?.path ||
          ""
        );

        confirmedQuestion = String(
          detail.question ||
          window.UXSSession?.deepQuestion ||
          ""
        );

        if (!confirmedText) return;

        waitingForMP3 = true;

        if (getMP3()) {
          waitingForMP3 = false;
          show();
        }
      }
    );

    root.addEventListener(
      "uxs:mp3-ready",
      () => {
        if (!waitingForMP3) return;

        if (confirmedText && getMP3()) {
          waitingForMP3 = false;
          show();
        }
      }
    );

    root.addEventListener(
      "uxs:audio-cleared",
      reset
    );

    root.addEventListener(
      "uxs:recording-started",
      updateQuestion
    );

    root.addEventListener(
      "uxs:recording-stopped",
      updateQuestion
    );

    no.addEventListener(
      "click",
      () => {
        if (busy) return;

        finish(
          "TU SEÑAL SE QUEDA CONTIGO.",
          "GRACIAS POR DEJARNOS ESCUCHARTE."
        );

        emit("uxs:share-declined");
      }
    );

    // =====================================
    // PREPARAR AUDIO ORIGINAL
    // =====================================

    async function getOriginalAudio() {
      const player =
        document.getElementById("uxs-playback");

      const source =
        player?.getAttribute("src") ||
        player?.src;

      if (!source) {
        throw new Error("ORIGINAL_AUDIO_MISSING");
      }

      const response = await fetch(source);

      if (!response.ok) {
        throw new Error("ORIGINAL_AUDIO_UNAVAILABLE");
      }

      const blob = await response.blob();

      if (
        !blob.size ||
        blob.size > 8 * 1024 * 1024
      ) {
        throw new Error("INVALID_ORIGINAL_AUDIO");
      }

      const mime =
        (blob.type || "").split(";")[0].toLowerCase();

      const extensions = {
        "audio/webm": "webm",
        "video/webm": "webm",
        "audio/mp4": "mp4",
        "video/mp4": "mp4",
        "audio/wav": "wav",
        "audio/x-wav": "wav",
        "audio/mpeg": "mp3",
        "audio/ogg": "ogg"
      };

      const extension = extensions[mime];

      if (!extension) {
        throw new Error("UNSUPPORTED_ORIGINAL_AUDIO");
      }

      return {
        blob,
        filename: `uxs-original.${extension}`
      };
    }

    // =====================================
    // COMPARTIR
    // =====================================

    yes.addEventListener(
      "click",
      async () => {
        if (busy) return;

        const mp3 = getMP3();

        if (!mp3) {
          feedback.textContent =
            "TU SEÑAL TODAVÍA SE ESTÁ PREPARANDO.";
          return;
        }

        if (
          !confirmedText ||
          !confirmedPath ||
          !confirmedQuestion
        ) {
          feedback.textContent =
            "FALTAN LOS DATOS DE TU RESPUESTA.";
          return;
        }

        if (!ENABLE_PRIVATE_UPLOAD) {
          feedback.textContent =
            "EL ENVÍO NO ESTÁ ACTIVADO.";
          return;
        }

        const currentGeneration = generation;

        busy = true;
        yes.disabled = true;
        no.disabled = true;

        feedback.textContent =
          "VERIFICANDO TU SEÑAL...";

        try {
          if (
            mp3.type !== "audio/mpeg" ||
            !mp3.size ||
            mp3.size > 2 * 1024 * 1024
          ) {
            throw new Error("INVALID_MP3");
          }

          // Obtener el audio original
          // únicamente tras el consentimiento.

          const original =
            await getOriginalAudio();

          if (currentGeneration !== generation) {
            return;
          }

          const supa = getClient();

          await ensureSession(supa);

          if (currentGeneration !== generation) {
            return;
          }

          const form = new FormData();

          form.append(
            "audio",
            mp3,
            "uxs-signal.mp3"
          );

          form.append(
            "original_audio",
            original.blob,
            original.filename
          );

          form.append(
            "transcript",
            confirmedText
          );

          form.append(
            "path",
            confirmedPath
          );

          form.append(
            "question",
            confirmedQuestion
          );

          form.append(
            "consent",
            "true"
          );

          feedback.textContent =
            "ENVIANDO TU SEÑAL...";

          const { data, error } =
            await supa.functions.invoke(
              FUNCTION_NAME,
              { body: form }
            );

          if (currentGeneration !== generation) {
            return;
          }

          if (error) {
            const details =
              await getFunctionError(error);

            console.error(
              "UXS SAVE ERROR",
              details
            );

            handleUploadError(details);
            return;
          }

          if (!data?.success || !data.signal_id) {
            finish(
              "NO PUDIMOS CONFIRMAR EL ENVÍO.",
              "REVISA EL ESTADO DE LA SEÑAL " +
              "ANTES DE INTENTARLO OTRA VEZ."
            );
            return;
          }

          const moderation =
            String(data.moderation_status || "pending");

          const relevance =
            String(data.relevance_status || "pending");

          const reason =
            String(data.moderation_reason || "unknown");

          if (moderation === "rejected") {
            if (
              relevance === "irrelevant" ||
              reason === "off_topic" ||
              reason === "spam"
            ) {
              finish(
                "ESTA SEÑAL NO TERMINA DE CONECTAR.",
                "LA RESPUESTA PARECE ALEJARSE " +
                "DE LA PREGUNTA.",
                true
              );

            } else {
              finish(
                "ESTA SEÑAL NO PUEDE COMPARTIRSE.",
                "PUEDES INTENTARLO CON OTRA RESPUESTA.",
                true
              );
            }

            emit("uxs:signal-rejected", {
              id: data.signal_id,
              moderation,
              relevance
            });

            return;
          }

          if (moderation === "needs_review") {
            finish(
              "TU SEÑAL NECESITA UNA SEGUNDA ESCUCHA.",
              "LA GUARDAMOS DE FORMA PRIVADA. " +
              "TODAVÍA NO SE HA COMPARTIDO."
            );

          } else if (
            moderation === "approved" &&
            relevance === "relevant"
          ) {
            finish(
              "TU SEÑAL HA SIDO RECIBIDA.",
              "TU RESPUESTA PASÓ LA REVISIÓN " +
              "Y ESTÁ LISTA PARA CONECTAR.",
              true
            );

          } else {
            finish(
              "TU SEÑAL SE HA GUARDADO.",
              "SIGUE PRIVADA HASTA QUE TERMINE " +
              "LA REVISIÓN AUTOMÁTICA."
            );
          }

          emit("uxs:signal-saved", {
            id: data.signal_id,
            status: data.status,
            moderation_status: moderation,
            relevance_status: relevance
          });

        } catch (error) {
          console.error(
            "UXS sharing",
            error
          );

          finish(
            "NO PUDIMOS PREPARAR TU SEÑAL.",
            "EL AUDIO NO SE PUDO VERIFICAR. " +
            "NO SE HA CONFIRMADO EL ENVÍO.",
            true
          );

        } finally {
          if (currentGeneration === generation) {
            busy = false;
            yes.disabled = false;
            no.disabled = false;
          }
        }
      }
    );

    updateQuestion();

    console.log(
      "UXS SHARE V8 READY"
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );
  } else {
    init();
  }
})();
